import angular from 'angular';
import moment from 'angular-moment';

import DateUtil from '../../../../components/logic/date_util/date_util.module';
import PowerFormatter from '../../../../components/logic/power-formatter/power-formatter.logic';
import DailyMaxDemandPowerService from '../../../../components/api/daily_max_demand_power/daily_max_demand_power.service';

import chartConfig from './compare-graph-weekly.config';

export class CompareGraphWeeklyDemandController {
  /*@ngInject*/
  constructor($filter, $scope, $q, moment, DateUtil, PowerFormatter, DailyMaxDemandPowerService) {
    this.$filter = $filter;
    this.moment = moment;
    this.$q = $q;
    this.DateUtil = DateUtil;
    this.PowerFormatter = PowerFormatter;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;

    this.startDate = this.DateUtil.beginningOfWeek(new Date());
    this.endDate = this.DateUtil.leapDate(this.startDate, 6);
    this.maxDate = this.DateUtil.beginningOfWeek(new Date());
    this.categories = [];
    this.Week = ['日', '月', '火', '水', '木', '金', '土'];
    this.graphUpdating = false;

    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.selectedConfigs', () => this.updateGraph(this.startDate, this.endDate));
    $scope.$watch('$ctrl.targetDate', () => {
      if (!this.targetDate) { return; }
      this.startDate = this.targetDate;
      this.endDate = this.DateUtil.leapDate(this.startDate, 6);

      this.updateGraph(this.startDate, this.endDate);
    });
  }

  $onInit() {}

  changeDate(diff) {
    this.updateTargetDate({targetDate: this.DateUtil.leapDate(this.startDate, diff)});
  }

  updateGraph(startDate, endDate) {
    if (this.chart) {
      this.chart.reflow();
    }
    if (this.selectedConfigs.length === 0) {
      return;
    }
    this.graphUpdating = true;
    this.resetSeries();

    this.categories = [];
    for (let i = 0; i < 7; i++) {
      let utc = this.DateUtil.localToUTC(startDate);
      this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
    }
    this.chart.xAxis[0].setCategories(this.categories);

    const promises = [];
    for (let config of this.selectedConfigs) {
      promises.push(this.getDemandData(config, this.categories, startDate, endDate));
    }

    this.$q.all(promises).then(results => {
      for (let result of results) {
        this.addSeries(result.powers, result.config);
      }
      this.chart.redraw();
      this.chart.reflow();
      this.graphUpdating = false;
    });
  }

  getDemandData(config, categories, startDate, endDate) {
    const dateQuery = this.DateUtil.getDateRangeQueries(startDate, endDate);
    const query = angular.extend({id: config.id}, dateQuery);

    return new Promise(resolve => {
      this.DailyMaxDemandPowerService.show(query, res => {
        const powers = this.PowerFormatter.formatDailyDemandPowers(res.powers, categories);
        resolve({powers, config});
      });
    });
  }

  addSeries(powers, config) {
    if (!powers) {
      return;
    }
    const graphData = this.categories.map((e, i) => {
      const label = this.moment(e).format('MM/DD');
      return [label, powers[i].y];
    });
    this.chart.addSeries({
      name: config.pms_service_code,
      type: this.graphType,
      data: graphData
    }, false);
  }

  resetSeries() {
    if (!this.chart) {
      return;
    }
    while (this.chart.series.length > 0) {
      this.chart.series[0].remove(false);
    }
  }
}

export default angular.module('leptonApp.compareGraphWeeklyDemand', [moment, DateUtil, PowerFormatter, DailyMaxDemandPowerService])
  .component('compareGraphWeeklyDemand', {
    template: require('./compare-graph-weekly.html'),
    controller: CompareGraphWeeklyDemandController,
    bindings: {
      selectedConfigs: '=',
      configIds: '=',
      graphType: '=',
      targetDate: '=',
      updateTargetDate: '&'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/demand/weekly/compare-graph-weekly.component.js